(function($) {
	if ( $('body').hasClass('home') ) {

		// // Hero Carousel
		// $('#js-hero-carousel').slick({
		// 	autoplay: true,
		// 	dots: false,
		// 	arrows: false,
		// 	speed: 10000,
		// 	autoplaySpeed: 0,
		// 	slidesToShow: 1,
		// 	cssEase: 'linear',
		// 	pauseOnHover: false,
		// 	pauseOnFocus: false
		// });

		// Plan
		$('#js-plan-carousel').slick({
			infinite: true,
			dots: false,
			arrows: true,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '8%',
			adaptiveHeight: false,
			variableWidth: true,

			responsive: [
				{
					breakpoint: 650,
					settings: {
						variableWidth: false
					}
				}
			]
		});

	}
})(jQuery);
